import {formatPrice, htmlDecode} from "@/lib/utils"

export interface IProduct {
    name: string
    brand: string
    currency: string
    url: string
    imageUrl: string
    price: number
    blockJSON: string
}

interface IProps {
    product: IProduct
    single?: boolean
}

const Product = ({product, single}: IProps) => {
    let hawk
    try {
        const data = JSON.parse(product.blockJSON)
        if (data?.hawk) {
            hawk = data.hawk
        }
    } catch {}

    let image
    if (product?.imageUrl?.length > 0) {
        image = <img className="p-[10px]" src={product.imageUrl} />
    }

    let sym = "$"
    if (product?.currency === "GBP") {
        sym = "£"
    }

    let price = null
    if (product?.price) {
        price = <div className="mt-2 flex text-[16px] font-normal tracking-[-0.2px]">{`${sym}${formatPrice(product.price)}`}</div>
    }

    let topClass = "bg-white w-[270px] min-h-[210px] m-[10px] ml-[5px] mr-[5px]"
    if (single) {
        topClass = "bg-white"
    }

    let productLink
    if (hawk != undefined && hawk.length > 0) {
        productLink = <div dangerouslySetInnerHTML={{__html: hawk}} />
    } else if (product?.url.length > 0) {
        productLink = (
            <a href={product?.url} target="shop">
                SHOP NOW
            </a>
        )
    }

    return (
        <div className={topClass}>
            <div className="grid grid-cols-[115px_auto] ">
                {image}
                <div className="ml-[10px] mr-[5px] pb-[10px]">
                    <div className="mt-[10px] flex text-[16px] font-normal uppercase leading-[26px] tracking-[1px]">
                        {htmlDecode(product?.brand)}
                    </div>
                    <div className="flex text-[18px] font-normal tracking-[-0.2px]">{htmlDecode(product?.name)}</div>
                    {price}
                    <div className="mt-2 flex text-[14px] text-sm tracking-[1px] underline underline-offset-2">{productLink}</div>
                </div>
            </div>
        </div>
    )
}

export default Product
